import axios from 'axios';
import { apiUrl } from '../appolloConfig';
import { AUTH_TOKEN } from '../helpers/user/authorization';

export const strapiAxios = axios.create({
  baseURL: apiUrl,
  timeout: 60000,
  headers: {
    Authorization: AUTH_TOKEN && AUTH_TOKEN
  }
});
export const unloggedStrapiAxios = axios.create({
  baseURL: apiUrl,
  timeout: 60000
});
export const instanceLoggedOrNot = localStorage.getItem('token')
  ? strapiAxios
  : unloggedStrapiAxios;
